import Collection from 'lib/client/collections/collection'
import IntegrationEntities from './IntegrationEntities'
import CurrentSyncStatus from './CurrentSyncStatus'
import FollowUps from './FollowUps'
import AppointmentRequests from './AppointmentRequests'
import Notes from './Notes'
import CovetrusAppointmentStatuses from './CovetrusAppointmentStatuses'

class Operations extends Collection {
    get integrationEntities(){
        return new IntegrationEntities(this.options)
    }
    get currentSyncStatus(){
        return new CurrentSyncStatus(this.options)
    }
    get followUps(){
        return new FollowUps(this.options)
    }
    get appointmentRequests(){
        return new AppointmentRequests(this.options)
    }
    get notes(){
        return new Notes(this.options)
    }
    get covetrusAppointmentStatuses(){
        return new CovetrusAppointmentStatuses(this.options)
    }
}

export default Operations


// WEBPACK FOOTER //
// ./src/lib/client/collections/organizations/operations/index.js